var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('white-blue-button',{class:_vm.css_class,attrs:{"title":"レッスン履歴を見る"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('ballot-check-icon')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }